import { useQuery } from "@tanstack/react-query";
import { permissionService } from "@/services/PermissionService";

export const permissionKeys = {
  all: ['permissions'],
  single: (id) => [...permissionKeys.all, id],
};

export const usePermissions = (options) => {
  return useQuery({
    queryKey: permissionKeys.all,
    queryFn: () => permissionService.getAllPermissions(),
    ...options,
  });
};

export const usePermission = (id, options) => {
  return useQuery({
    queryKey: permissionKeys.single(id),
    queryFn: () => permissionService.getPermission(id),
    enabled: !!id,
    ...options,
  });
}; 